import React from 'react'
import { Form } from 'antd';
import { Grid, TextField, Snackbar } from '@material-ui/core';
import MySnackbarContentWrapper from "../../../components/SnackBar";

class LayoutTypeForm extends React.Component {
  state = {
    confirmDirty: false,
    autoCompleteResult: [],
    snackOpen : false,
    snackType: "info",
    snackMessage: "Action executing..."
  };
  
  handleClose = () => {
    this.setState({ snackOpen: false });
  };

  setStateValues = (open,type,message) => {
    this.setState({ snackOpen: open });
    this.setState({ snackType: type });
    this.setState({ snackMessage: message });
  }

  handleSubmit = (e) => {
    e.preventDefault();
    this.setState({ snackOpen: true });
    this.props.form.validateFieldsAndScroll((err, values) => {
      if (!err) {
        this.props.query_f({ variables: { id: this.props.id, name: values.name, description: values.description } }).then(result =>{
          this.setStateValues(true,"success","Action executed with success!");
          this.props.form.resetFields();
          if(this.props.onCancel){
            this.props.onCancel();
          }
          localStorage.setItem('adireto-drawer-open', false);
        }, error=>{
          this.setStateValues(true,"error","Action executed with error!");          
        });
      }
      else{
        this.setStateValues(true,"error","Form validation failed!");  
      }
    });
  }
  handleConfirmBlur = (e) => {
    const value = e.target.value;
    this.setState({ confirmDirty: this.state.confirmDirty || !!value });
  }

  render() {
    const { getFieldDecorator } = this.props.form;

    return (
      <form id="myForm" onSubmit={this.handleSubmit}>
        <Snackbar anchorOrigin={{ vertical: 'bottom', horizontal: 'right', }} open={this.state.snackOpen} autoHideDuration={6000} onClose={this.handleClose}>
          <MySnackbarContentWrapper onClose={this.handleClose} variant={this.state.snackType} message={this.state.snackMessage}/>
        </Snackbar>
        <Grid container spacing={0}>
        <Grid item xs={12}>
          {getFieldDecorator('name', {
            initialValue: (this.props.name || ''),
            rules: [{ required: true, message: 'Please input your name!', whitespace: true }],
          })(
            <TextField
                  id="name"
                  label="name"
                  color="primary"
                  fullWidth
                  style={{ marginTop : 13 }}
                  InputLabelProps={{
                    shrink : true,
                  }}
                  placeholder="name"
                />
          )}
        </Grid>
        <Grid item xs={12}>
          {getFieldDecorator('description',
           {
            initialValue: (this.props.description || ''),
            rules: [{ required: true, message: 'Please input your description!', whitespace: true }],
          })(
            <TextField
                  id="description"
                  label="description"
                  color="primary"
                  fullWidth
                  style={{ marginTop : 13 }}
                  InputLabelProps={{
                    shrink : true,
                  }}
                  placeholder="description"
                />
          )}
        </Grid>
        </Grid>
        </form>
    );
  }
}

const LayoutTypesForm = Form.create()(LayoutTypeForm);

export default LayoutTypesForm